import React, { useEffect, useState } from "react";
import { Box, Card, Link, Stack, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { resetPassword } from "../apis/apiList/authApi";
import { useMessage } from "../context/MessageContext";
import { useFormik } from "formik";
import * as Yup from "yup";

function ResetPassword() {
  const navigate = useNavigate();
  const { showMessage } = useMessage();

  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [errorPass, setErrorPass] = useState("");
  const [errorCPass, setErrorCPass] = useState("");

  const validationSchema = Yup.object({
    password: Yup.string()
      // .length(6, "Password must be exactly 6 characters")
      .min(3, "Password must be at least 6 characters")
      .max(15, "Password cannot be more than 15 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      console.log("Password Reset Successful!", values);

      const userData = {
        password: values.password,
        confirmPassword: values.confirmPassword,
      };

      try {
        if (token) {
          const response = await resetPassword(token, userData);
          console.log("response", response);
          if (response.success) {
            showMessage(response.message, "success");
            navigate("/");
          }
        } else {
          showMessage("Reset Token not found", "error");
        }
      } catch (err) {
        showMessage(err?.response?.data?.message, "error");
      }
    },
  });

  const validatePassword = () => {
    console.log("vakud");
    if (!password || !confirmPassword) {
      setError("Both fields are required.");
      return false;
    }
    if (password.length >= 6) {
      console.log("6");
      setErrorPass("Password must be exactly 6 characters.");
      return false;
    }

    if (password !== confirmPassword) {
      setErrorCPass("Confirm Passwords do not match.");
      return false;
    }

    setError("");
    setErrorPass("");
    setErrorCPass("");
    return true;
  };

  //   const handleSubmit = async () => {
  //     console.log("running");
  //     if (validatePassword()) {

  //     }
  //   };

  const inputGap = {
    marginBottom: "15px",
  };

  return (
    <div className="reset-password-section">
      <div className="reset-password-section-in">
        <Stack direction={"row"} justifyContent={"center"} gap={12}>
          <Box>
            <img src="/images/login-graphics.png" />
          </Box>
          <Box width={"23%"}>
            <div className="reset-password-form">
              <h2>Reset Password</h2>
              <form onSubmit={formik.handleSubmit}>
                <div className="form-group-reset" style={inputGap}>
                  <input
                    type="password"
                    placeholder="Password*"
                    name="password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                  />
                  {formik.touched.password && formik.errors.password && (
                    <Typography style={{ color: "red", fontSize: "14px" }}>
                      {formik.errors.password}
                    </Typography>
                  )}
                </div>

                <div className="form-group-reset" style={inputGap}>
                  <input
                    type="password"
                    placeholder="Confirm Password*"
                    name="confirmPassword"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.confirmPassword}
                  />
                  {formik.touched.confirmPassword &&
                    formik.errors.confirmPassword && (
                      <Typography style={{ color: "red", fontSize: "14px" }}>
                        {formik.errors.confirmPassword}
                      </Typography>
                    )}
                </div>

                <div className="form-group-reset" style={inputGap}>
                  <button type="submit" className="btn-signin sign-marg-no">
                    Submit
                  </button>
                </div>
              </form>

              <Box className="LostForgot">
                <div className="form-group-reset">
                  <Typography
                    sx={{ cursor: "pointer" }}
                    onClick={() => navigate("/")}
                  >
                    Click here for Login
                  </Typography>
                </div>
              </Box>
              {/* <div>
                <h2>Reset Password</h2>
                <div className="form-group-reset" style={inputGap}>
                  <input
                    type="password"
                    placeholder="Password*"
                    name="password"
                    onChange={(e)=>{setPassword(e.target.value)}}
                    autoFocus
                  />
                  {errorPass && <Typography>{errorPass}</Typography>}
                </div>
                <div className="form-group-reset" style={inputGap}>
                  <input
                    type="password"
                    placeholder="Confirm Password*"
                    name="confirmPassword"
                    onChange={(e)=>{setConfirmPassword(e.target.value)}}
                    autoFocus
                  />
                  {errorCPass && <Typography>{errorCPass}</Typography>}
                </div>
                <div className="form-group-reset" style={inputGap}>
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="btn-signin sign-marg-no"
                  >
                    Submit
                  </button>
                </div>
                <Box className="LostForgot">
                  <div className="form-group-reset">
                    <Typography
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate("/");
                      }}
                    >
                      Click here for Login
                    </Typography>
                  </div>
                </Box>
              </div> */}
            </div>
          </Box>
        </Stack>
      </div>
      <Box className="LoginFooter">
        <div className="container-fluid">
          <div className="row">
            <Typography color="#fff">
              Copyright © Association Studios. All Right Reserved.
            </Typography>
          </div>
        </div>
      </Box>
    </div>
  );
}

export default ResetPassword;
